import { render, staticRenderFns } from "./notice_privacy.vue?vue&type=template&id=7aaa8db4&scoped=true"
import script from "./notice_privacy.vue?vue&type=script&lang=js"
export * from "./notice_privacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaa8db4",
  null
  
)

export default component.exports